export default __webpack_public_path__ + "static/media/FinanceRealCase-en.9fc54705.jpg";